import { c as _c } from "react/compiler-runtime";
import { useIncidentPolling } from "@/hooks/incident/useIncidentPolling";
import { useDetectRecentlyResolved } from "./hooks/useDetectRecentlyResolved";
import { IncidentFullScreenAlert } from "./uis/IncidentFullScreenAlert";
import { IncidentInfoBar } from "./uis/IncidentInfoBar";
import { IncidentResolvedBanner } from "./uis/IncidentResolvedBanner";

/**
 * AssessmentIncident（障害発生・復旧通知）の表示制御。
 *
 * 優先順位:
 *   1. active に critical が 1 件以上あれば全画面アラート
 *   2. 1 に該当しなければ、active に info があれば上部帯
 *   3. 直前 active だった id が今回 recentlyResolved に出ていれば復旧バナー
 */
export const IncidentBanner: React.FC = () => {
  const $ = _c(14);
  const {
    active,
    recentlyResolved
  } = useIncidentPolling();
  const {
    resolvedToShow,
    dismiss
  } = useDetectRecentlyResolved(active, recentlyResolved);
  let t0;
  if ($[0] !== active) {
    t0 = active.filter(_temp);
    $[0] = active;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const criticals = t0;
  if (criticals.length > 0) {
    let t1;
    if ($[2] !== criticals) {
      t1 = <IncidentFullScreenAlert incidents={criticals} />;
      $[2] = criticals;
      $[3] = t1;
    } else {
      t1 = $[3];
    }
    return t1;
  }
  let t1;
  if ($[4] !== active) {
    t1 = active.filter(_temp2);
    $[4] = active;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  const infos = t1;
  let t2;
  if ($[6] !== infos) {
    t2 = infos.length > 0 && <IncidentInfoBar incidents={infos} />;
    $[6] = infos;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  let t3;
  if ($[8] !== dismiss || $[9] !== resolvedToShow) {
    t3 = resolvedToShow.length > 0 && <IncidentResolvedBanner incidents={resolvedToShow} onDismiss={dismiss} />;
    $[8] = dismiss;
    $[9] = resolvedToShow;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  let t4;
  if ($[11] !== t2 || $[12] !== t3) {
    t4 = <>{t2}{t3}</>;
    $[11] = t2;
    $[12] = t3;
    $[13] = t4;
  } else {
    t4 = $[13];
  }
  return t4;
};
function _temp(i) {
  return i.severity === "critical";
}
function _temp2(i_0) {
  return i_0.severity === "info";
}